import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';
import {NationalDrugFormularyLinkDTO} from './NationalDrugFormularyLinkDTO';

export class NationalDrugFormularyDTO extends BaseDTO {
  nationalDrugFormularyId: number;
  name: string;
  formularyClass: NameValueDTO;
  startDate: Date;
  endDate: Date;
  nationalDrugs: NationalDrugFormularyLinkDTO[];
}
